import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from '@shell/composables/useI18n';
import { _VIEW } from '@shell/config/query-params';
import { useStore } from 'vuex';
import Tab from '@shell/components/Tabbed/Tab.vue';
import { useTemplateRef } from 'vue';
import ResourceYaml from '@shell/components/ResourceYaml.vue';
import { YamlProps } from '@shell/components/Drawer/ResourceDetailDrawer/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'YamlTab',
  props: {
    resource: {},
    yaml: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);
const yamlComponent: any = useTemplateRef('yaml');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    class: "yaml-tab",
    name: "yaml-tab",
    label: _unref(i18n).t('component.drawer.resourceDetailDrawer.yamlTab.title'),
    onActive: _cache[0] || (_cache[0] = () => yamlComponent.value?.refresh())
  }, {
    default: _withCtx(() => [
      _createVNode(ResourceYaml, {
        ref: "yaml",
        value: props.resource,
        yaml: props.yaml,
        mode: _unref(_VIEW)
      }, null, 8, ["value", "yaml", "mode"])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})